import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import SuccessIcon from "@mui/icons-material/Check";
import ErrorIcon from "@mui/icons-material/ReportProblem";
import "./AppMessage.css";

const AppMessage = ({
  isOpen = false,
  onClose,
  message = "",
  messageType = "info",
}) => {
  //builders
  const BuildIcon = () => {
    if (messageType === "success") return <SuccessIcon />;
    else if (messageType === "error") return <ErrorIcon />;
    else return <InfoIcon />;
  };

  return (
    <>
      {isOpen && (
        <div className={`app-message app-message-${messageType} `}>
          <div className={`icon icon-${messageType} `}>{BuildIcon()}</div>
          <div className="message">{message}</div>
          <div className="close-button" onClick={onClose}>
            <CloseIcon />
          </div>
        </div>
      )}
    </>
  );
};

export default AppMessage;
